import tariffHelper from "./tariffHelper"
import { errorPrettifier } from "./errorPrettifier"

const Story = {
  Prologue: "There was an error processing the change of tenancy",
  Ending: "Please try again",
}

const isGasTariff = (message: string) =>
  /[E|G][1|2]R-[A-Z]{4}-[0-9]{2}M-[A-Z]*/.test(message.split("'")[1]) &&
  tariffHelper.isGas(message.split("'")[1])

const getDateFromMessage = (message: string) =>
  message.split(" ")[message.split(" ").length - 1]

const cotErrorMatcher = (message: string) => [
  {
    errors: ["Contact must have a phone1"],
    message: `${Story.Prologue}. The primary contact must have a primary phone number before submitting the change of tenancy.`,
  },
  {
    errors: ["Contact address must have a postcode"],
    message: `${Story.Prologue}. Please ensure there is a postcode in the forwarding address.`,
  },
  {
    errors: ["Contact must have a surname"],
    message: `${Story.Prologue}. Please ensure the primary contact has a surname and try again.`,
  },
  {
    errors: [
      "The following accounts will be affected by the COT, but were not listed in the request",
      "The following accounts were listed in the request, but will not be affected by the COT",
    ],
    message: `${Story.Prologue}. Please make sure you are on the current active account before processing the change of tenancy.`,
  },
  {
    errors: [
      "If a directDebitInfo element is present, it must have a bankAccountNumber",
    ],
    message: `${Story.Prologue}. Please ensure all Direct Debit information is provided if setting up a direct debit for the customer. Otherwise, ensure all fields are empty.`,
  },
  {
    errors: ["Postcode mismatch with provided"],
    message: `${Story.Prologue} due to a postcode mismatch. ${Story.Ending}.`,
  },
  {
    errors: [
      "Contact address must have an address1",
      "is an unrecognized field (line 1) in element",
    ],
    message: `${Story.Prologue}. ${Story.Ending} and ensure the forwarding address is correctly populated.`,
  },
  {
    errors: [
      "Unrecognised asset type: MPAN for asset with id",
      "Unrecognised asset type: MPRN for asset with id",
    ],
    message: `${Story.Prologue}. Please ensure the meterpoints and meters are correctly set up on the account.`,
  },
  {
    errors: ["BankSortCode must not be all zeros"],
    message: `${Story.Prologue}. Please try again and ensure the DD details are correctly populated.`,
  },
  {
    errors: [
      "Property has an electricity supply, so an electricity product bundle must be specified",
    ],
    message: `${Story.Prologue}. Please ensure there are active tariffs for all meterpoints and then try again.`,
  },
  {
    errors: ["Product bundle"],
    message: `${Story.Prologue}. The ${
      isGasTariff(message) ? "gas" : "electricity"
    } tariff must start on or before ${getDateFromMessage(message)}.`,
  },
]

export const cotErrorPrettifier = (error, isMoveOut = false) => {
  const errorMessage = isMoveOut ? error : errorPrettifier(error)
  const genericError = `${Story.Prologue}. ${Story.Ending}`

  if (!errorMessage) return genericError // If error cannot be prettified then show generic error

  const match = cotErrorMatcher(errorMessage).find((matcher) =>
    matcher.errors.find((err) => errorMessage.includes(err)),
  )

  return match?.message || genericError // If no match, then show generic error
}
